import { stringIsNullOrEmpty } from "./Formatting";

import { UploadBlobToContainerResponse } from "@cubeconServer/modules/azure-blob/azure-blob.entity";

export function getApiUrl(): string {
	const { hostname } = window.location;
	if (hostname === 'localhost') {
		return 'http://localhost:9000/api';
	}
	return `https://${hostname}/api`;
}

export const API_URL = getApiUrl();

export async function apiRequest(api: string, params: string = "", accessToken?: string, loadToken?: string): Promise<any> {
	const headers = new Headers();
	if (!stringIsNullOrEmpty(accessToken)) {
		headers.append("Authorization", "Bearer " + accessToken);
	}
	if (loadToken) {
		headers.append("LoadToken", loadToken)
	}

	const options = {
		method: "GET",
		headers: headers
	}
	return fetch(buildApiRequest(api, params), options).then(res => {
		const type = res.headers.get("content-type");
		if (type?.startsWith("application/json")) {
			return res.json();
		}
		else {
			return res.text();
		}
	});
}

export async function apiPost(api: string, body: any, accessToken?: string): Promise<Response> {
	return fetchJsonImpl("POST", api, body, accessToken);
}

export async function apiDelete(api: string, body: any, accessToken?: string): Promise<Response> {
	return fetchJsonImpl("DELETE", api, body, accessToken);
}
async function fetchJsonImpl(verb: string, api: string, body: any, accessToken?: string): Promise<Response> {
	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	if (accessToken) {
		headers.append("Authorization", "Bearer " + accessToken);
	}

	const options = {
		method: verb,
		headers: headers,
		body: JSON.stringify(body)
	}
	return fetch(new Request(buildApiRequest(api), options));
}

export async function apiUploadFile(container: string, file: File, callback: (response: UploadBlobToContainerResponse) => void, accessToken?: string) {
	const req = new XMLHttpRequest();
	req.open("POST", buildApiRequest(`images/${container}`), true);
	if (accessToken) req.setRequestHeader("Authorization", `Bearer ${accessToken}`);
	req.onreadystatechange = () => {
		if (req.readyState === XMLHttpRequest.DONE) {
			callback(JSON.parse(req.responseText) as UploadBlobToContainerResponse);
		}
	};
	var fd = new FormData();
	fd.append("file", file);
	req.send(fd);

}


function buildApiRequest(...args: string[]): string {
	args = args.filter(arg => (arg?.length ?? 0) > 0);
	return API_URL + (args.length > 0 ? "/" + args.join("/") : "");
}
